import { Alert, Button, CircularProgress, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Typography } from "@mui/material"
import { useReducer, useState } from "react"
import { useNavigate } from "react-router-dom"
import { z } from 'zod'
import cep from 'cep-promise'

import InputMask  from 'react-input-mask'
import useInternalFetch from "../../../api/apiInternal"
import config from "../../../common/Config"

const CreditCardForm = (props) => {

	const [inputFields, dispatch] 				= useReducer(reducer, {})
	const navigate								= useNavigate()
	const internalFetch							= useInternalFetch()
	const stateList								= ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO']

	const [isSearching, setIsSearching]			= useState(false)
	const [isSaving, setIsSaving]				= useState(false)
	const [highlightErrors, setHighlightErrors]	= useState(false)
	const [returnObject, setReturnObject]		= useState()

	const handleSubmit = () => {
		setIsSaving(true)

		if (inputFields.isValid) {
			const options = {
				method : "PATCH",
				headers : {
					"Content-Type" : "application/json"	
				},
				body : JSON.stringify(inputFields)
			}
			
			internalFetch(config.apiUrl +'/subscription/'+ props.subscriptionId, options)
			.then(result => {
				if (result.success) {
					setIsSaving(false)					
					navigate('/subscription', { state : { returnMessage: 'Cartão alterado com sucesso!' }} )
				}
				else {
					setIsSaving(false)					
					setReturnObject(result)
				}
			})

		}
		else {
			setIsSaving(false)
			setHighlightErrors(true)
		}
	}

	const handleCepSearch = (e) => {
		const currentZipCode = e.target.value.replace(/[^0-9]/,'')
		setIsSearching(true)

		cep(currentZipCode)
		.then(result => {
			if (result.name !== 'CepPromiseError') {
				dispatch({type : 'update', field : 'address', payload: result.street })
				dispatch({type : 'update', field : 'neighborhood', payload: result.neighborhood })
				dispatch({type : 'update', field : 'city', payload: result.city })
				dispatch({type : 'update', field : 'state', payload: result.state })
			}
			setIsSearching(false)
		})
		.catch(e => setIsSearching(false))
	}	

	return (
		<Stack direction={'column'} sx={{width: '100%'}}>
			{returnObject ? (
				<Grid item xs="12">
					<Alert severity={returnObject.success ? "success" : "error"} onClose={() => setReturnObject(null)} sx={{mt: 2, ml: 2, mr: 2}}>{returnObject.message}</Alert>
				</Grid>
			) : null}				
			<Paper elevation={2} sx={{padding: 1, margin: 2}}> 
				<Typography fontWeight={'bold'} paddingBottom={1}>Seus Dados</Typography>
				<Grid container spacing={1}>
					<Grid item xs="4">
							<InputMask 
								mask={'99999-999'}
								maskChar=""
							label="CEP" 
							name="zipCode"
							value={inputFields.zipCode || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'zipCode', payload: e.target.value})}
							onBlur={handleCepSearch}
							error={highlightErrors && inputFields.errors?.zipCode}
							helperText={highlightErrors && inputFields.errors?.zipCode}
							fullWidth
							>{(inputProps) => 
								<TextField {...inputProps} />
							}
						</InputMask>	
					</Grid>
					<Grid item xs="8">
						<TextField 
							label="Endereço" 
							name="address"
							value={inputFields.address || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'address', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.address}
							helperText={highlightErrors && inputFields.errors?.address}
							disabled={isSearching}
							InputProps={{
								endAdornment: isSearching ? (
								<InputAdornment position="end">
									<CircularProgress size={20} />
								</InputAdornment>
								) : null,
							}}															
							fullWidth
						/>	
					</Grid>
					<Grid item xs="6">
						<TextField 
							label="Número" 
							name="addressNumber"
							value={inputFields.addressNumber || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'addressNumber', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.addressNumber}
							helperText={highlightErrors && inputFields.errors?.addressNumber}
							fullWidth
						/>					
					</Grid>			
					<Grid item xs="6">
						<TextField 
							label="Complemento" 
							name="addressOther"
							value={inputFields.addressOther || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'addressOther', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.addressOther}
							helperText={highlightErrors && inputFields.errors?.addressOther}
							fullWidth					
						/>				
					</Grid>		
					<Grid item xs="5">
						<TextField 
							label="Bairro" 
							name="neighborhood"
							value={inputFields.neighborhood || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'neighborhood', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.neighborhood}
							helperText={highlightErrors && inputFields.errors?.neighborhood}
							disabled={isSearching}
							InputProps={{
								endAdornment: isSearching ? (
								<InputAdornment position="end">
									<CircularProgress size={20} />
								</InputAdornment>
								) : null,
							}}		
							fullWidth
						/>					
					</Grid>
					<Grid item xs="5">
						<TextField 
							label="Cidade" 
							name="city"
							value={inputFields.city || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'city', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.city}
							helperText={highlightErrors && inputFields.errors?.city}
							disabled={isSearching}
							InputProps={{
								endAdornment: isSearching ? (
								<InputAdornment position="end">
									<CircularProgress size={20} />
								</InputAdornment>
								) : null,
							}}		
							fullWidth
						/>	
					</Grid>
					<Grid item xs="2">
						<FormControl fullWidth>
							<InputLabel id="state-label">Estado</InputLabel>
							<Select
								labelId="state-label"
								value={inputFields.state || ''}
								label="Estado"
								onChange={(e) => dispatch({type: 'update', field : 'state', payload: e.target.value})}
								error={highlightErrors && inputFields.errors?.state}
								helperText={highlightErrors && inputFields.errors?.state}
								MenuProps={{
									PaperProps: {sx: {maxHeight: '300px'}},
								}}									
								disabled={isSearching}
								endAdornment={
									isSearching ? (
										<InputAdornment sx={{margin: 3}}>
											<CircularProgress size={20} />
										</InputAdornment>
									) : null
								}									
								>
								{stateList.map(s => (<MenuItem value={s}>{s}</MenuItem>))}
							</Select>
						</FormControl>							
					</Grid>
				</Grid>
				
			</Paper>
				
			<Paper elevation={2} sx={{padding: 1, margin: 2}}> 
				<Typography fontWeight={'bold'} paddingBottom={1} color={'#303030'}>Dados do seu Cartão</Typography>
				<Grid container spacing={1}>
					<Grid item xs="12">
						<TextField 
							label="Nome no Cartao" 
							name="cardHolder"
							value={inputFields.cardHolder || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'cardHolder', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.cardHolder}
							helperText={highlightErrors && inputFields.errors?.cardHolder}
							fullWidth
						/>	
					</Grid>
					<Grid item xs="12">
						<TextField 
							label="Numero do Cartao" 
							name="cardNumber"
							value={inputFields.cardNumber || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'cardNumber', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.cardNumber}
							helperText={highlightErrors && inputFields.errors?.cardNumber}
							fullWidth
						/>	
					</Grid>
					<Grid item xs="6">
						<InputMask
							mask='99/99'
							value={inputFields.cardExpireDate || ''}
							disabled={false}
							onChange={(e) => dispatch({type: 'update', field : 'cardExpireDate', payload: e.target.value})}		
							label="Vencimento" 
							name="cardExpireDate"
							error={highlightErrors && inputFields.errors?.cardExpireDate}
							helperText={highlightErrors && inputFields.errors?.cardExpireDate}
							fullWidth
							>{(inputProps) => 
								<TextField {...inputProps}/>
							}
						</InputMask>
					</Grid>
					<Grid item xs="6">
						<TextField 
							label="CVV" 
							name="cvv"
							value={inputFields.cvv || ''} 
							onChange={(e) => dispatch({type: 'update', field : 'cvv', payload: e.target.value})}
							error={highlightErrors && inputFields.errors?.cvv}
							helperText={highlightErrors && inputFields.errors?.cvv}
							fullWidth
						/>
					</Grid>
				</Grid>
			</Paper>

			<Stack direction={'row'} spacing={1} justifyContent={'right'} sx={{pr: 2}}>
				<Button variant="contained" type="submit" sx={{width: 100}} onClick={handleSubmit} disabled={isSaving}>Alterar</Button>
				<Button variant="contained" type="submit" sx={{width: 100}} color="secondary" onClick={() => navigate('/subscription')} disabled={isSaving}>Cancelar</Button>
			</Stack>			
		</Stack>
	)
}

const reducer = (inputFields, action) => {
	let updatedFields = inputFields

	switch (action.type) {

		case 'update' : {
			updatedFields = {
				...updatedFields,
				[action.field] : action.payload
			}
		}

	}

	const zodParseResults = inputFieldsSchema.safeParse(updatedFields)

	updatedFields.isValid 	= zodParseResults.success
	updatedFields.errors	= parseZodErrors(zodParseResults)

	return updatedFields
}

const inputFieldsSchema = z.object({
	zipCode				: z.string({required_error: 'Preencha o CEP'}).regex(/^\d{5}-\d{3}$/, 'CEP Inválido'),
	address				: z.string({required_error: 'Preencha o endereço.'}),
	addressNumber		: z.string({required_error: 'Preencha o número do endereço.'}),
	neighborhood		: z.string({required_error: 'Preencha o bairro.'}),
	city				: z.string({required_error: 'Preencha a cidade.'}),
	state				: z.string({required_error: 'Selecione o estado.'}),	
	cardHolder			: z.string({required_error: 'Preencha o nome do titular do cartão'}),
	cardNumber			: z.string({required_error: 'Preencha o número do cartão'}).regex(/^\d{13,19}$/, {message : 'Número do cartão inválido'}),
	cardExpireDate	 	: z.string({required_error: 'Preencha a validade do cartão'}).regex(/^\d{2}\/\d{2}$/, {message: 'Data da validade inválida'}),
	cvv					: z.string({required_error: 'Preencha o CVV do cartão'}).regex(/^\d{3,4}$/, {message: 'CVV inválido'})
})

const parseZodErrors = (pErrors) => {
	return pErrors.error?.issues?.reduce( (errors, e) => ({...errors, [e.path[0]] : e.message}), {})
}


export default CreditCardForm